import {ApplicationConfig, DEFAULT_CURRENCY_CODE, LOCALE_ID, provideZoneChangeDetection} from '@angular/core';
import {provideRouter} from '@angular/router';
import {routes} from './app.routes';
import {provideHttpClient, withInterceptors, withInterceptorsFromDi} from '@angular/common/http';
import {provideAnimations} from "@angular/platform-browser/animations";
import {provideToastr} from "ngx-toastr";
import {registerLocaleData} from "@angular/common";
import ptBr from '@angular/common/locales/pt';
import {provideEnvironmentNgxMask} from "ngx-mask";
import {provideLoadingBarInterceptor} from "@ngx-loading-bar/http-client";
import {provideLoadingBarRouter} from "@ngx-loading-bar/router";
import {provideNgxWebstorage, withLocalStorage, withNgxWebstorageConfig, withSessionStorage} from "ngx-webstorage";
import {authInterceptor} from "@core/interceptors/auth.interceptor";
import {provideTranslation} from "@core/services/provide-translation.config";

registerLocaleData(ptBr, 'pt-BR');

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({eventCoalescing: true}),
        provideLoadingBarInterceptor(),
        provideLoadingBarRouter(),
        provideRouter(routes),
        provideNgxWebstorage(
            withNgxWebstorageConfig({separator: ':', caseSensitive: true, prefix: 'fisconly'}),
            withLocalStorage(),
            withSessionStorage()
        ),
        provideHttpClient(withInterceptors([authInterceptor])),
        provideTranslation(),
        provideAnimations(),
        provideToastr(),
        {provide: LOCALE_ID, useValue: 'pt-BR'},
        {provide: DEFAULT_CURRENCY_CODE, useValue: 'R$'},
        provideEnvironmentNgxMask()
    ]
};


